import PractitionerProfile from './PractitionerProfile';

export default PractitionerProfile;
